import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["begin", "end"]

  connect() {
    this.isEndMimicable = !this.beginTarget.value || this.beginTarget.value === this.endTarget.value

    // If begin has value but end doesn't, copy the value
    if (this.beginTarget.value && !this.endTarget.value) {
      this.endTarget.value = this.beginTarget.value
      this.isEndMimicable = true
    }
  }

  // Handle input events on the begin field
  beginInput(event) {
    if (this.isEndMimicable) {
      this.endTarget.value = event.currentTarget.value
    }
  }

  // Handle input and blur events on the end field
  endInputOrBlur(event) {
    if (this.isEndMimicable && (this.beginTarget.value || this.endTarget.value)) {
      this.isEndMimicable = false
    }
  }
}
